import React, { useState, useContext, useEffect } from "react";
import { Button, IconButton, Tooltip } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { CustomSearchBar } from "./CustomSearchBar";
import { AuthContext } from "../contexts/AuthContext";
import { encontrarModulo } from "../helpers/encontrarModulo";

export const ActionsBar = (props) => {

    const [permission, setPermission] = useState({});
    const { addAction, father, module, searchAction, searchPlaceholder, component } = props;
    const classes = useStyles();

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);

    useEffect(() => {
        let unsubscribed = true;

        if(unsubscribed) setPermission(encontrarModulo(permisos, module, father));
 
        return () => unsubscribed = false;
    }, [permisos, module]);

    return (
        <div className={classes.main}>
            <div className={ classes.containerButtons }>
                {
                    (permission?.actions?.find(e => e?.name === 'crear') && (permission?.actions?.find(e => e?.name === 'crear')?.active || rol?.includes('admin'))) && (
                        <Tooltip title='Nuevo'>
                            <IconButton onClick={ addAction }>
                                <AddOutlined />
                            </IconButton>
                        </Tooltip>
                    )
                }

                { component }
            </div>

            <CustomSearchBar action={ searchAction } placeholder={ searchPlaceholder } />
        </div>
    );
}

ActionsBar.defaultProps = {
    addAction: () => false,
    father: null,
    module: null,
    searchAction: () => false,
    searchPlaceholder: null,
    component: <></>
}

const useStyles = makeStyles({
    main: {
        background: '#fff',
        borderRadius: 4,
        marginTop: 10,
        padding: 10,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    containerButtons: {
        display: 'flex',
        alignItems: 'center',
        gap: 5
    },
    addButton: {
        textTransform: 'capitalize !important',
        background: '#00365F !important',
        color: '#fff !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important'
        }
    }
})